import * as actions from './slice'

const getCampaignList = {
  eventName: 'campaignSearch',
  onSuccess: [{ action: actions.getCampaignList, redux: true }
  ]
}

const addCampaignList = {
  eventName: 'campaignSearch',
  onSuccess: [{ action: actions.addCampaignList, redux: true }
  ]
}

export {
  getCampaignList,
  addCampaignList
}
